import { useCallback, useRef } from 'react';

const useBackdropCloseGuard = () => {
  const mouseDownOnBackdropRef = useRef(false);

  const resetBackdropGuard = useCallback(() => {
    mouseDownOnBackdropRef.current = false;
  }, []);

  const onBackdropMouseDown = useCallback((event) => {
    mouseDownOnBackdropRef.current = event.target === event.currentTarget;
  }, []);

  const buildOnBackdropClick = useCallback((onClose, canClose = true) => {
    return (event) => {
      const allowClose = typeof canClose === 'function' ? canClose() : Boolean(canClose);

      if (
        event.target === event.currentTarget
        && mouseDownOnBackdropRef.current
        && allowClose
        && typeof onClose === 'function'
      ) {
        onClose();
      }

      mouseDownOnBackdropRef.current = false;
    };
  }, []);

  return {
    onBackdropMouseDown,
    buildOnBackdropClick,
    resetBackdropGuard,
  };
};

export default useBackdropCloseGuard;